export default __webpack_public_path__ + "static/media/Parallax-HUD-03.7d1302de.jpg";